import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postRequestItem({ body }) {
  return BaseService.post(REST.REQUEST_ITEM, body);
}

function putRequestItem({ body, id }) {
  return BaseService.put(REST.REQUEST_ITEM_ID(id), body);
}

function putRequestItemApproval({ body, id }) {
  return BaseService.put(REST.REQUEST_ITEM_APPROVAL_ID(id), body);
}

function getRequestItem(params) {
  return BaseService.get(REST.REQUEST_ITEM, {
    params: paramsFilter({ params }),
  });
}

function getRequestItemApproval(params) {
  return BaseService.get(REST.REQUEST_ITEM_APPROVAL, {
    params: paramsFilter({ params }),
  });
}

function deleteRequestItem({ id }) {
  return BaseService.delete(REST.REQUEST_ITEM_ID(id));
}

export default {
  getRequestItem,
  deleteRequestItem,
  postRequestItem,
  putRequestItem,
  putRequestItemApproval,
  getRequestItemApproval,
};
